module.exports = __webpack_public_path__ + "media/n15.2fdfe8df.mp4";